import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ExternalIdModel} from '../externalId.model';
import {LovValueSummaryConverter} from '../../../../lov/lov-value/api/converter/LovValueSummary.converter';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class ExternalIdConverter extends HttpModelConverter<ExternalIdModel> {

    protected createInstance(): ExternalIdModel {
        return new ExternalIdModel();
    }

    protected enrichObject(result: ExternalIdModel, src: ExternalIdModel) {
        result.application = new LovValueSummaryConverter().convert(result.application);
    }
}
